(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Contracts_Add_Handler = (function(superClass) {
    extend(Contracts_Add_Handler, superClass);

    function Contracts_Add_Handler() {
      return Contracts_Add_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Add_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout-add-select';
      this.layoutSelector = App.sidebar.contentDiv().find('#add');
      return this.loadLayout();
    };

    Contracts_Add_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      $('#contract_number').mask('99 - 9999 - 99', {
        placeholder: ' '
      });
      this.parent.makeValidation('Saving Contract');
      return $('#contract_number').keypress(function(event) {
        var contractPrefix;
        if (event.which === 13) {
          event.preventDefault();
        }
        contractPrefix = this.value.substr(0, 2).trim();
        if (contractPrefix.length >= 2) {
          return $("#sales_zone option").each(function() {
            $(this).removeProp("selected");
            if ($(this).text().substr(0, 2).trim() === contractPrefix) {
              return $(this).prop("selected", "selected");
            }
          });
        }
      });
    };

    return Contracts_Add_Handler;

  })(Handler);

}).call(this);
